import { render } from "./PieChart.vue?vue&type=template&id=85117584&scoped=true"
import script from "./PieChart.vue?vue&type=script&lang=js"
export * from "./PieChart.vue?vue&type=script&lang=js"

import "./PieChart.vue?vue&type=style&index=0&id=85117584&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85117584"]])

export default __exports__